import React from "react";
import {
  Box,
  Card,
  CardContent,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import { useNavigate } from "react-router-dom";
import logo from "../../../assest/images/logo.jpg"

export default function ResetSuccessful() {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/sign-in");
  };
  return (
    <Box>
        <Box sx={{p:4}} >
        <img src={logo} alt="log img" style={{height:"60px", width:"140px"}} />
        </Box>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "60vh",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
          gap: 2,
          width: "100%",
        }}
      >
        <Card
          sx={{
            flex: 1,
            maxWidth: 400,
            padding: 4,
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            textAlign:"center"
          }}
        >
          <CardContent>
            <MaterialTypography variant="h6" fontWeight="bold" gutterBottom>
              Password Reset Successful
            </MaterialTypography>
            <MaterialTypography
              sx={{ marginBottom: 2, color: "#989898", fontSize: "14px" }}
            >
              Your password has been reset successfully. You can now log in using your new credentials.
            </MaterialTypography>
           
            <MaterialBox
              sx={{ display: "flex", justifyContent: "center" }}
              my={2}
            >
              <MaterialButton
                variant="contained"
                onClick={() => {
                  handleLogin();
                }}
                sx={{
                  background: colors.buttonColor,
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Go To Log In Page
              </MaterialButton>
            </MaterialBox>
          </CardContent>
        </Card>
      </Box>
    </Box>
    </Box>
  );
}
